

export default function Image({src, srcSet, alt, className}){
    return (
       <>
        <img src={src} alt={alt} className={className} /> 
       </>
        
    )
}